
import React from 'react'

function Footer() {
    return (
        <footer className="w3-container w3-padding-16 w3-dark-grey w3-center">
            <h4>Project: DST-1239-EED</h4>
            <p>Designed by <a href="/">Shwetank</a></p>
        </footer>
    )
}

export default Footer
